<script>
import { Container, Draggable } from "vue-dndrop";

export default {
  components: {
    Container,
    Draggable
  },

  emits: ['selectPatch', 'reorderSelect', 'reorderPatches'],

  props: {
    patches: {
      type: Array,
      required: true
    },
    currentPatch: {
      type: Number,
      required: true
    }
  },

  methods: {
    selectPatch(index) {
      this.$emit('selectPatch', index);
    },

    drop(event) {
      const { removedIndex, addedIndex } = event;
      const movedItem = this.patches.splice(removedIndex, 1)[0];
      const originalSelectedPatch = this.currentPatch;
      this.patches.splice(addedIndex, 0, movedItem);

      // Keep the same patch highlighted after the move. This only shifts the
      // index — it must NOT go through selectPatch, which closes the panel.
      let newSelected;
      if (originalSelectedPatch === removedIndex) {
        newSelected = addedIndex;
      } else if (originalSelectedPatch > removedIndex && originalSelectedPatch <= addedIndex) {
        newSelected = originalSelectedPatch - 1;
      } else if (originalSelectedPatch < removedIndex && originalSelectedPatch >= addedIndex) {
        newSelected = originalSelectedPatch + 1;
      } else {
        newSelected = originalSelectedPatch;
      }

      this.$emit('reorderSelect', newSelected);
      this.$emit('reorderPatches', this.patches);
    }
  }
}
</script>
<template>
  <Container tag="ul" class="menu p-0 w-full gap-0.5 patch-list" @drop="drop"
    :lock-axis="'y'"
    :animation-duration="0"
    :should-animate-drop="() => { return false }"
    >
    <Draggable v-for="(patch, index) in patches" :key="patch.uuid" :tag="{value: 'li'}" class="patch-item">
      <a @click="selectPatch(index)" :class="{ 'menu-active': index === currentPatch}" class="flex items-center">
        <span class="grow truncate">
          {{ patch.title }}
        </span>
        <span class="badge badge-sm badge-ghost patch-badge grow-0">
          <span class="opacity-50">PC:</span>
          <span>{{ index }}</span>
        </span>
      </a>
    </Draggable>
  </Container>
</template>

<style scoped>
.patch-list :deep(.patch-item a) {
  position: relative;
}

.patch-badge {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  font-size: 0.7rem;
  opacity: 0.7;
}
</style>